import { Field } from 'formik'

const CheckboxesField = ({name, optionGroups}) => {    
    return <div>
        {optionGroups.map((group, groupIndex) => {
            return <div key={groupIndex}  className="grid grid-cols-2">
            {group.label ? <div className="font-bold text-lg">{group.label}</div> : null}
            {group.options.map((option, index) => {
                return <div key={index} className="mb-2.5">
                    <label className="flex items-center gap-4 font-bold">
                        <Field type="checkbox" className="h-7 w-7 rounded border-gray-300 text-brand focus:ring-brand" name={name} value={option.value}/>
                        <span>{option.label}
                            {option.description ? <span className="text-neutral-300 text-sm ml-2">{option.description}</span> : null}
                        </span>
                    </label>
                </div>
            })}
            </div>
        })}
    </div>
  }

export default CheckboxesField;